import React, { useState } from "react";

const QualificationDetails = ({ data, setData, errors = {} }) => {
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };


  return (
    <>
      <div className="row g-3">

        <div className="row">
          <div className="col-lg-4 mb-3">
            <div className="form-row-flex">
              <label className="form-label-flex">
                SSLC School Name :
              </label>
              <div className="input-wrapper">
                <input
                  name="sslcschool"
                  className="custom-input"
                  value={data.sslcschool || ""}
                  onChange={handleChange}
                />
                {errors.sslcschool && (
                  <small className="error-text">{errors.sslcschool}</small>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">
                SSLC Year of Passing  :
              </label>
              <div className="input-wrapper">
                <input
                  type="number"
                  name="sslcyearpass"
                  className="custom-input1"
                  placeholder="YYYY"
                  min="1950"
                  max={new Date().getFullYear()}
                  value={data.sslcyearpass || ""}
                  onChange={handleChange}
                />
                {errors.sslcyearpass && (
                  <small className="error-text">{errors.sslcyearpass}</small>
                )}
              </div>

            </div>
          </div>
        </div>
        <div className="row">

          <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">

                HSC School Name  :
              </label>
              <div className="input-wrapper">
                <input
                  name="hscschoolname"
                 className="custom-input"
                  value={data.hscschoolname || ""}
                  onChange={handleChange}
                />
                {errors.hscschoolname && (
                  <small className="error-text">{errors.hscschoolname}</small>
                )}
              </div>

            </div>
          </div>


          <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">

                HSC Year of Passing  :
              </label>
              <div className="input-wrapper">
                <input
                  type="number"
                  name="hscyearpass"
                 className="custom-input1"
                  placeholder="YYYY"
                  min="1950"
                  max={new Date().getFullYear()}
                  value={data.hscyearpass || ""}
                  onChange={handleChange}
                />
                {errors.hscyearpass && (
                  <small className="error-text">{errors.hscyearpass}</small>
                )}
              </div>

            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">

                UG Degree :
              </label>
              <div className="input-wrapper">
                <input
                  name="ugdegree"
                className="custom-input"
                  value={data.ugdegree || ""}
                  onChange={handleChange}
                />
                {errors.ugdegree && (
                  <small className="error-text">{errors.ugdegree}</small>
                )}
              </div>
            </div>
          </div>

          {/* UG Stream */}
          <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">
                UG Stream :
              </label>
              <div className="input-wrapper">
                <input
                  name="ugstream"
                 className="custom-input1"
                  value={data.ugstream || ""}
                  onChange={handleChange}
                />
                {errors.ugstream && (
                  <small className="error-text">{errors.ugstream}</small>
                )}
              </div>

            </div>
          </div>

          <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">
                UG Year of Passing  :
              </label>
              <div className="input-wrapper">
                <input
                  type="number"
                  name="ugyearpass"
                  className="custom-input"
                  placeholder="YYYY"
                  min="1950"
                  max={new Date().getFullYear()}
                  value={data.ugyearpass || ""}
                  onChange={handleChange}
                />
                {errors.ugyearpass && (
                  <small className="error-text">{errors.ugyearpass}</small>
                )}
              </div>

            </div>
          </div>

        
        </div>
        <div className="row">

          <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">
                PGDegree  :
              </label>
              <div className="input-wrapper">
                <input
                  name="pgdegree"
                 className="custom-input"
                  value={data.pgdegree || ""}
                  onChange={handleChange}
                />
                {errors.pgdegree && (
                  <small className="error-text">{errors.pgdegree}</small>
                )}
              </div>

            </div>
          </div>
          <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">

                PG Stream  :
              </label>
              <div className="input-wrapper">
                <input
                  name="pgstream"
                 className="custom-input1"
                  value={data.pgstream || ""}
                  onChange={handleChange}
                />
                {errors.pgstream && (
                  <small className="error-text">{errors.pgstream}</small>
                )}
              </div>

            </div>
          </div>
          <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">
                PG Year of Passing :
              </label>

              <div className="input-wrapper">
                <input
                  type="number"
                  name="pgyearpass"
                  className="custom-input"
                  placeholder="YYYY"
                  min="1950"
                  max={new Date().getFullYear()}
                  value={data.pgyearpass || ""}
                  onChange={handleChange}
                />

                {errors.pgyearpass && (
                  <small className="error-text">{errors.pgyearpass}</small>
                )}
              </div>

            </div>
          </div>
      
        </div>

        <div className="row">
     <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">

                UG CGPA  :
              </label>

              <div className="input-wrapper">
                <input
                  name="ugcgpa"
                  className="custom-input"
                  value={data.ugcgpa || ""}
                  onChange={handleChange}
                />
                {errors.ugcgpa && (
                  <small className="error-text">{errors.ugcgpa}</small>
                )}
              </div>

            </div>
          </div>

             <div className="col-lg-4 mb-3">
            <div className="form-row-flex">

              <label className="form-label-flex">

                PG CGPA  :
              </label>
              <div className="input-wrapper">
                <input
                  name="pgcgpa"
                 className="custom-input1"
                  value={data.pgcgpa || ""}
                  onChange={handleChange}
                />
                {errors.pgcgpa && (
                  <small className="error-text">{errors.pgcgpa}</small>
                )}
              </div>

            </div>
          </div>

        </div>

     
           

      </div>
    </>
  );
};

export default QualificationDetails;
